import script from "./PerfilUsuarioView.vue?vue&type=script&setup=true&lang=js"
export * from "./PerfilUsuarioView.vue?vue&type=script&setup=true&lang=js"

import "./PerfilUsuarioView.vue?vue&type=style&index=0&id=070cab2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-070cab2c"]])

export default __exports__